import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../../../../service/authentication-service";

@Component({
    selector: 'app-event-management',
    templateUrl: './event-management.component.html',
    standalone: false
})
export class EventManagementComponent implements OnInit {

  isAdmin = false
  showRemoveEventsModal = false
  showTransferEventsModal = false

  constructor(private authService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.isPrivilegedUser()
  }

  toggleRemoveAllEventsEventModal() {
    this.showRemoveEventsModal = !this.showRemoveEventsModal
  }

  toggleTransferEventsModal() {
    this.showTransferEventsModal = !this.showTransferEventsModal
  }
}
